module.exports = __webpack_public_path__ + "img/codelos-logo.535d5826.svg";